import axiosInstance from "shared/services";
import {
  IUsersTempResponse,
  IUsersTempCreateResponse,
  IUsersTemp,
  IUsersTempAuthResponse,
} from "modules/users-temp/types";

const uri = "users-temp";

export const all = async (): Promise<IUsersTempResponse> =>
  axiosInstance.get(uri).then();

export const create = async (
  data: IUsersTemp
): Promise<IUsersTempCreateResponse> => axiosInstance.post(uri, data).then();

export const expireNow = async (id: number) =>
  axiosInstance.post(`${uri}/expire`, { id }).then();

export const auth = async (token: string): Promise<IUsersTempAuthResponse> =>
  axiosInstance.post(`${uri}/auth`, { token }).then();
